import { FC, useState, KeyboardEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { SearchConfig } from './header.types';
import styles from './header.module.css';

interface SearchBoxProps {
  config: SearchConfig;
}

const SearchBox: FC<SearchBoxProps> = ({ config }) => {
  const { t } = useTranslation();
  const [query, setQuery] = useState('');

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      config.onSearch(query);
    }
  };

  return (
    <div className={styles.searchBox}>
      <div className={styles.searchInputWrapper}>
        <input
          type="text"
          value={query}
          onChange={e => setQuery(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder={config.placeholder || t('common.searchPlaceholder')}
          className={styles.searchInput}
        />
        <div className={styles.searchIcon}>🔍</div>
      </div>
    </div>
  );
};

export default SearchBox;
